import { render, staticRenderFns } from "./StartingPoint.vue?vue&type=template&id=52d78467&"
import script from "./StartingPoint.vue?vue&type=script&lang=js&"
export * from "./StartingPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports